import React from 'react';
const links = ['Términos y Condiciones', 'Política de Privacidad', 'Contacto'];
export function Footer() {
  return <footer className="bg-brand-text text-white/70 py-12 px-4 text-center text-sm border-t border-white/10" data-id="element-62" data-mp="3ggaohovss12a">
      <div className="max-w-4xl mx-auto" data-id="element-63" data-mp="32pff8bhdzhy6">
        <p className="text-white font-serif font-bold text-xl tracking-wide mb-8" data-id="element-64" data-mp="36pfu1x8edv5r">
          PILATES <span className="font-script font-bold normal-case" data-id="element-65" data-mp="36n3bbhutfgrn">Listo</span>{' '}
          360™️
        </p>

        <nav aria-label="Enlaces legales" className="flex flex-wrap items-center justify-center gap-6 mb-8" data-id="element-66" data-mp="38qu4u3bljp2">
          {links.map(link => <a key={link} href="#" className="transition-colors duration-150 ease-smooth hover:text-white" data-id="element-67" data-mp="3lggbusv1b1ek">
              {link}
            </a>)}
        </nav>

        <p className="text-xs text-white/60 max-w-md mx-auto mb-4" data-id="element-68" data-mp="2eya0jzn6mvpg">
          Material profesional para instructores. No reemplaza la indicación
          médica ni kinesiológica.
        </p>

        <p data-id="element-69" data-mp="3gagz5ny8f937">&copy; 2026 Pilates Listo 360 — Todos los derechos reservados</p>
      </div>
    </footer>;
}